
import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Schema.org JSON-LD for homepage
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "SeninYolun - Esin Arifoğlu Koçluk",
      "description": "Ankara'da ICF akredite profesyonel koçluk hizmetleri - öğrenci koçluğu, ebeveyn koçluğu, kariyer koçluğu",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "telephone": "+90 312 417 8811",
      "email": "bilgi@seninyolun.net",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Bestekar Cd 78/11",
        "addressLocality": "Çankaya",
        "postalCode": "06680",
        "addressRegion": "Ankara",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "39.9334",
        "longitude": "32.8597"
      },
      "openingHours": [
        "Mo-Fr 11:00-16:00",
        "Sa 11:00-16:00"
      ],
      "provider": {
        "@type": "Person",
        "name": "Esin Arifoğlu",
        "jobTitle": "ICF Akredite Koç",
        "description": "25+ yıl deneyimli fizik öğretmeni ve ICF akredite koçu",
        "alumniOf": "Katı Hal Fiziği Yüksek Lisans",
        "knowsAbout": ["Öğrenci Koçluğu", "Ebeveyn Koçluğu", "Kariyer Koçluğu", "Kişisel Gelişim"]
      },
      "areaServed": {
        "@type": "City",
        "name": "Ankara"
      },
      "serviceType": ["Öğrenci Koçluğu", "Ebeveyn Koçluğu", "Kariyer Koçluğu"],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Koçluk Hizmetleri",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Öğrenci Koçluğu",
              "description": "Akademik başarı ve kişisel gelişim için öğrenci koçluğu hizmetleri"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ebeveyn Koçluğu",
              "description": "Etkili ebeveynlik ve aile dinamikleri için koçluk hizmetleri"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kariyer Koçluğu",
              "description": "Profesyonel gelişim ve kariyer planlama koçluğu hizmetleri"
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <WhyChooseSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
